import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme:any) =>
  createStyles({
    root:{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: (props:any) => props.padding??"5rem 10rem 0 10rem"
    }
  }),
);

interface IFormLoadingWrapper {
  children:any,
  padding?:string
}

export  function FormLoadingWrapper(props:IFormLoadingWrapper) {
  const classes = useStyles(props);
  return (
    <div className={classes.root}>
      {props.children}
    </div>
  )
}
